import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-dgenerator',
    templateUrl: './dgenerator.component.html',
    styleUrls: ['./dgenerator.component.scss']
})
export class DgeneratorComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}